import { FieldLabel, Select } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';

export function CurrencyInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Amount column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <div style={{ display: 'flex', gap: 6 }}>
        <div style={{ flex: 1 }}>
          <FieldLabel>From</FieldLabel>
          <Select value={c.from || 'USD'} onChange={(v) => u({ from: v })}
            options={['USD', 'EUR', 'GBP', 'JPY', 'BRL', 'INR', 'MXN', 'SEK', 'NOK', 'CHF'].map(v => ({ value: v, label: v }))} />
        </div>
        <div style={{ flex: 1 }}>
          <FieldLabel>To</FieldLabel>
          <Select value={c.to || 'EUR'} onChange={(v) => u({ to: v })}
            options={['USD', 'EUR', 'GBP', 'JPY', 'BRL', 'INR', 'MXN', 'SEK', 'NOK', 'CHF'].map(v => ({ value: v, label: v }))} />
        </div>
      </div>
      <FieldLabel hint="Use the rate as of this date">As of date column</FieldLabel>
      <ColSelect value={c.dateCol} onChange={(v) => u({ dateCol: v })} placeholder="— use today's rate —" />
      <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
    </div>
  );
}
